<template>
  <div>
    <div>{{ plaintiff }}</div>
    <div>{{ uploadOCRList }}</div>
    <v-btn @click="logPlaintiffData">LOG PLAINTIFF DATA</v-btn>
    <v-btn @click="createAndStampTest">TEST CREATE AND STAMP</v-btn>

    <!-- <div> -->
    <v-card
      style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800"
      outlined
      tile
      rounded
      class="ma-auto"
      dense
      hover
      @click="goToPropounding"
    >
      <v-card-text class="display-1 text-center">
        PROPOUND DISCOVERY
      </v-card-text>
    </v-card>
    <!-- </div> -->
    <v-form class="ma-2 pa-2" @submit.prevent="uploadAndProcessRFPs" ref="form">
      <div>
        <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800"
          outlined
          tile
          rounded
          class="ma-auto"
          dense
        >
          <v-card-title
            >RESPOND TO DISCOVERY: REQUEST FOR PRODUCTION OF
            DOCUMENTS</v-card-title
          >
          <div class="ma-2 mt-2">
            <v-file-input
              class="ma-2 mt-6"
              autofocus
              outlined
              chips
              multiple
              label="Upload Test Documents"
              ref="fileInput"
              @change="onFilePicked"
              dense
              color="#a07800"
            ></v-file-input>
          </div>
          <v-card>
            <ol class="ma-auto">
              <li v-for="(file, index) in documentList" :key="index">
                <v-layout>
                  <div class="ma-auto">{{ file.name }}</div>
                  <v-btn small text rounded @click="removeFile(index)">
                    <v-icon color="red">mdi-minus-circle</v-icon>
                  </v-btn>
                </v-layout>
              </li>
            </ol>
          </v-card>
          <v-card-actions>
            <v-layout row class="mt-2 ml-2">
              <v-btn rounded :disabled="!formIsValid" dark type="submit"
                >SUBMIT</v-btn
              >
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-actions>
        </v-card>

        <div v-for="name in documentNames" :key="name">{{ name }}</div>
        <canvas
          id="crop-canvas"
          :height="canvasHeight"
          :width="canvasWidth"
          style="display: none;"
        ></canvas>
        <canvas
          id="temp-canvas"
          :height="canvasHeight"
          :width="canvasWidth"
          style="display: none;"
        ></canvas>
        <v-card
          style="border: 1px solid #a07800; max-width: 900px"
          outlined
          tile
          light
          class="ma-auto"
          dense
        >
          <v-card-title>IMAGE</v-card-title>
          <div v-if="coordinates">
            LEFT: {{ coordinates.left }} HEIGHT: {{ coordinates.height }} TOP:
            {{ coordinates.top }} WIDTH: {{ coordinates.width }}
          </div>
          <v-card-actions>
            <v-btn large v-if="coordinates" @click="crop">CROP</v-btn>
          </v-card-actions>
          <div v-for="(image, index) in imageList" :key="index">
            <cropper
              class="cropper"
              :src="image"
              @change="change"
              :height="canvasHeight"
              :width="canvasWidth"
            ></cropper>
          </div>
          <cropper
            class="cropper"
            :src="imageData"
            @change="change"
            :height="canvasHeight"
            :width="canvasWidth"
          ></cropper>
        </v-card>
        <!-- <v-card
          style="border-radius: 26px; border: 1px solid #a07800; max-width: 900px"
          outlined
          tile
          light
          class="ma-auto"
          dense
        >
        <v-card-title>IMAGE</v-card-title>
          
        </v-card>-->

        <!-- THIS WAS A TEST -->
        <!-- <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800"
          outlined
          tile
          rounded
          class="ma-auto"
          dense
        >
          <div class="ma-2 mt-2">
            <v-file-input
              class="ma-2 mt-6"
              autofocus
              outlined
              chips
              multiple
              label="Upload Test Documents"
              ref="fileInput"
              @change="onFilePicked"
              dense
              color="#a07800"
            ></v-file-input>
          </div>
          <v-card>
            <ol class="ma-auto">
              <li v-for="(file, index) in documentList" :key="index">
                <v-layout>
                  <div class="ma-auto">{{ file.name }}</div>
                  <v-btn small text rounded @click="removeFile(index)">
                    <v-icon color="red">mdi-minus-circle</v-icon>
                  </v-btn>
                </v-layout>
              </li>
            </ol>
          </v-card>
          <v-card-actions>
            <v-layout row class="mt-2 ml-2">
              <v-btn rounded :disabled="!formIsValid" dark type="submit">SUBMIT</v-btn>
              <v-spacer></v-spacer>
            </v-layout>
          </v-card-actions>
        </v-card>-->
      </div>
    </v-form>
  </div>
</template>

<script>
/**
 * THIS COMPONENT IS A WORK IN PROGRESS
 * NOT PRODUCTION READY
 */
import firebase from "firebase";
import { mask } from "vue-the-mask";

// import { degrees, PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
import { PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
// import { PDFDocument } from "pdf-lib";
// import { async } from "q";
// import * as moment from "moment";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import * as pdfjsLib from "pdfjs-dist";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Cropper } from "vue-advanced-cropper";

export default {
  directives: {
    mask,
  },
  components: {
    Cropper,
  },
  data: () => ({
    plaintiff: null,
    testDoc: null,
    newPDF: null,
    documentList: [],
    canvasWidth: 150,
    canvasHeight: 150,
    canvasSource: null,
    firstPage: null,
    imageData: null,
    imageList: [],
    documentNames: [],
    buffer: null,
    coordinates: null,
    croppedPDF: null,
    uploadOCRList: null,
    pageCount: 0,
    docName: null,
    // cropValue: null,
    // cropImg: '',
    // data: null
  }),
  computed: {
    matter() {
      return this.$store.getters.getMatter(this.$route.params.id);
    },
    formIsValid() {
      return this.documentList !== null;
    },
  },
  watch: {
    plaintiff(val) {
      console.log("plaintiff", val);
      window.document.title = `DISCOVERY - ${val.fullName.toUpperCase()}`;
    },
    uploadOCRList(val) {
      if (val !== null && val !== undefined) {
        console.log("this.uploadOCRList val:", val);
        let tempRef = `matters/${this.matter.matterSlug}/plaintiff/${
          this.plaintiff.clientSlug
        }/readDocTest/${this.docName}output-1-to-${this.pageCount + 1}.json`;
        let savedJsonRef = firebase
          .app()
          .storage()
          .refFromURL(`gs://taplaw_read_doc_test_results/results/${tempRef}`);

        savedJsonRef.getDownloadURL().then((url) => {
          // let xhr = new XMLHttpRequest();
          console.log("url", url);
          //   firebase
          // .firestore()
          // .collection("matters")
          // .doc(this.$route.params.id)
          // .collection("plaintiff")
          // .doc(this.$route.params.client)
        });
      }
    },
  },
  methods: {
    goToPropounding() {
      let windowName = `${this.plaintiff.fullName} PROPOUNDING`;
      let windowLink = `${this.$route.path}/propounding`;
      window.open(windowLink, windowName);
      // console.log(this.$route.path);
      // this.$router.replace('/propound');
    },
    crop() {
      (async () => {
        // let coordinates = this.coordinates
        let buffer = this.buffer;
        let uploadedPDF = await PDFDocument.load(buffer);
        //create a new pdf with pdf-lib
        let newCroppedPDF = await PDFDocument.create();
        //grab the pages of the uploaded pdf with pdf-lib
        let uploadedPages = await uploadedPDF.getPages();
        //draw each page of the uploaded pdf onto the new pdf
        //(I did it this way because I was scaling it down for bates numbring purposes)
        await uploadedPages.forEach((uploadedPage) => {
          (async () => {
            // if you know the crop you want already, this will work
            // I need the user to crp the page
            await console.log(this.coordinates);

            let left = this.coordinates.left;
            let top = this.canvasHeight - this.coordinates.top;
            let bottom =
              this.canvasHeight -
              this.coordinates.top -
              this.coordinates.height;
            let right = this.coordinates.width + this.coordinates.left;
            let l = Math.round(left);
            let t = Math.round(top);
            let b = Math.round(bottom);
            let r = Math.round(right);

            // console.log("left", l);
            // console.log("top", t);
            // console.log("bottom", b);
            // console.log("right", r);
            let embeddedPage = await newCroppedPDF.embedPage(uploadedPage, {
              left: l,
              bottom: b,
              right: r,
              top: t,
            });

            let page = await newCroppedPDF.addPage(PageSizes.Letter);
            await page.drawPage(embeddedPage);
          })();
        });
        //name the new croppedPDF
        this.docName = this.documentNames[0];
        newCroppedPDF.setTitle(`${this.docName || "null"}`);
        //create a unit8array
        const pdfBytes = await newCroppedPDF.save();
        //Create a blob pdf of the new pdf
        this.croppedPDF = await URL.createObjectURL(
          new Blob([pdfBytes], {
            type: "application/pdf",
          })
        );
        let croppedPDFblob = new Blob([pdfBytes], {
          type: "application/pdf",
        });
        console.log("croppedPDF", this.croppedPDF);
        window.open(this.croppedPDF, "_blank");

        //
        //
        // if (this.formIsValid) {
        // this.documentList.forEach(doc => {
        console.log(
          "running read doc funciton by saving this cropped document"
        );
        // const docName = doc.name;
        const ref = firebase
          .app()
          .storage("gs://taplaw_read_doc_test")
          .ref(
            `matters/${this.matter.matterSlug}/plaintiff/${this.plaintiff.clientSlug}/readDocTest/${this.docName}`
          );
        ref
          .put(croppedPDFblob)
          .then(() => {
            console.log("testDoc successfully stored");
            let count = 0;
            uploadedPages.forEach(() => {
              count++;
              this.pageCount = count;
            });
            // let tempRef = `matters/${this.matter.matterSlug}/plaintiff/${
            //   this.plaintiff.clientSlug
            // }/readDocTest/${this.docName}output-1-to-${this.pageCount + 1}.json`;
            // let savedJsonRef = firebase
            //   .app()
            //   .storage()
            //   .refFromURL(
            //     `gs://taplaw_read_doc_test_results/results/${tempRef}`
            //   );

            // savedJsonRef.getDownloadURL().then((url) => {
            //   // let xhr = new XMLHttpRequest();
            //   console.log("url", url);
            // });

            //OR
            // firebase.app().storage(`gs://taplaw_read_doc_test_results`).refFromURL(`gs://taplaw_read_doc_test_results/results/${tempRef}`)

            // //call function with the new cropped pdf to be read by the cloud
            // //function readAndAnalyze
            // const readAndAnalyze = firebase
            //   .functions()
            //   .httpsCallable("readAndAnalyze");
            // readAndAnalyze({
            //   croppedPDFblob: croppedPDFblob,
            //   matterSlug: this.matter.matterSlug,
            //   plaintiffSlug: this.plaintiff.clientSlug,
            // }).then((result) => {
            //   let data = result.data;
            //   console.log("data:", data);
            // });

            // })
            // .catch((e) => {
            //   console.error(e);
            // });
            // this.documentList = [];
          })
          .catch((e) => {
            console.error(e);
          });
        // })
        // }
      })();
    },
    change({ coordinates, canvas }) {
      console.log("coordinates", coordinates);
      console.log("canvas", canvas);
      this.coordinates = { ...coordinates };
    },
    uploadAndProcessRFPs() {
      (async () => {
        this.documentList.forEach((doc) => {
          this.documentNames.push(doc.name);

          (async () => {
            //loading pdf
            await console.log("doc just uploaded", doc);
            //make it a buffer
            let buffer = await doc.arrayBuffer();
            //save the buffer to the data attribute of this component
            this.buffer = buffer;
            //load the buffer with pdf-lib
            const uploadedPDF = await PDFDocument.load(buffer);
            //create a new pdf with pdf-lib
            // const newPdfDoc     = await PDFDocument.create();
            //grab the pages of the uploaded pdf with pdf-lib
            const uploadedPages = await uploadedPDF.getPages();

            //grab the first page
            const firstPage = uploadedPages[0];
            //get the size of the first page
            const { width, height } = await firstPage.getSize();
            await console.log("docwidth", width);
            await console.log("docheight", height);
            //set the cropbox width and height to display and crop
            this.canvasWidth = width;
            this.canvasHeight = height;

            await console.log("buffer:", buffer);
            //  const pdfjsLib  = await import('pdfjs-dist/build/pdf');
            //declare the worker
            const pdfjsWorker = await import(
              "pdfjs-dist/build/pdf.worker.entry"
            );
            //not sure why I have to do this
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

            //feed the uploaded document buffer to pdfjs
            await pdfjsLib
              .getDocument(buffer)
              .promise.then((pdf) => {
                // you can now use *pdf* here
                console.log("pdf", pdf);
                //get the first page
                // for (let index = 0; index < pdf._pdfInfo.numPages; index++) {
                //   pdf
                //     .getPage(index)
                //     .then((page) => {
                //       // you can now use *page* here
                //       let scale = 1.0;
                //       //decrale the viewport
                //       let viewport = page.getViewport({ scale: scale });
                //       //grab the invisible canvas from the dom

                //       let tempcanvas = document.getElementById("myCanvas");

                //       //set the context of the canvas (2d)
                //       let context = tempcanvas.getContext("2d");
                //       //render the first page to the invisible cnavas using pdfjs
                //       page
                //         .render({ canvasContext: context, viewport: viewport })
                //         .promise.then(() => {
                //           //convert the pdf to a jpeg using pdfjs
                //           //this then sets the source attribute of the vue-cropper component in the virtual dom
                //           let tempImageData = tempcanvas.toDataURL(
                //             "image/jpeg"
                //           );
                //           this.imageList.push(tempImageData);
                //           document.getElementById("myCanvas").remove();
                //         })
                //         .catch((e) => {
                //           console.error(e);
                //         });
                //     })
                //     .catch((e) => {
                //       console.error(e);
                //     });
                // }
                pdf
                  .getPage(1)
                  .then((page) => {
                    // you can now use *page* here
                    let scale = 1.0;
                    //decrale the viewport
                    let viewport = page.getViewport({ scale: scale });
                    //grab the invisible canvas from the dom
                    let canvas = document.getElementById("temp-canvas");
                    //set the context of the canvas (2d)
                    let context = canvas.getContext("2d");
                    //render the first page to the invisible cnavas using pdfjs
                    page
                      .render({ canvasContext: context, viewport: viewport })
                      .promise.then(() => {
                        //convert the pdf to a jpeg using pdfjs
                        //this then sets the source attribute of the vue-cropper component in the virtual dom
                        this.imageData = canvas.toDataURL("image/jpeg");
                        // this.imageList.push(imageData);
                      })
                      .catch((e) => {
                        console.error(e);
                      });
                  })
                  .catch((e) => {
                    console.error(e);
                  });
              })
              .catch((e) => {
                console.error(e);
              });
          })();
        });
        /*
/////////////prior version 
            await uploadedPages.forEach(uploadedPage =>{
              
              (async () => {
              
                
                // // if you know the crop you want already, this will work
                // // I need the user to crp the page
                // let embeddedPage = await newPdfDoc.embedPage(uploadedPage, {
                //   left: 72,
                //   bottom: 720,
                //   right: 550,
                //   top: 0,
                // });

                
                let embeddedPage = await newPdfDoc.embedPage(uploadedPage);
                let page = await newPdfDoc.addPage(PageSizes.Letter);
 
                //test
                await page.drawPage(embeddedPage)
                //test

                //shouldnt this be outside foreach loop?
                // const pdfBytes = await newPdfDoc.save();
               

                // SHouldnt this be outside the loop?
                //for PDF return
                // this.newPDF = await URL.createObjectURL(
                //   new Blob([pdfBytes], {
                //     type: "application/pdf"
                //   })
                // );
              
                //shouldnt this be outside the loop?
                // return window.open(this.newPDF, "_blank");
                // return pdfBytes
              })()
              
            })







            //draw each page of the uploaded pdf onto the new pdf 
            //(I did it this way because I was scaling it down for bates numbring purposes)
            
            await uploadedPages.forEach(uploadedPage =>{              
              (async () => { 

                // // if you know the crop you want already, this will work
                // // I need the user to crp the page
                // let embeddedPage = await newPdfDoc.embedPage(uploadedPage, {
                //   left: 72,
                //   bottom: 720,
                //   right: 550,
                //   top: 0,
                // });

                let embeddedPage = await newPdfDoc.embedPage(uploadedPage);
                let page = await newPdfDoc.addPage(PageSizes.Letter);
                await page.drawPage(embeddedPage)
              })()
            })
            //create a unit8array 
            const pdfBytes = await newPdfDoc.save();
            //Create a blob pdf of the new pdf
            this.newPDF = await URL.createObjectURL(
              new Blob([pdfBytes], {
                type: "application/pdf"
              })
            );
/////////////end prior version 

*/

        // BATES NUMBERING ALGO
        // // loading pdf we just created with pdfMake as an array buffer
        // const generatedPDF = await PDFDocument.load(this.testDoc);
        // await console.log("generatedPDF", generatedPDF);

        // //now we cerate a new pdf with pdf-lib
        // const newPdfDoc = await PDFDocument.create();
        // //now we embed the created PDF
        // let generatedPages = await generatedPDF.getPages();
        // await console.log(generatedPages);
        // await generatedPages.forEach(generatedPage => {
        //   console.log("each page in generatedPages", generatedPage);
        //   (async () => {
        //     let embeddedPage = await newPdfDoc.embedPage(generatedPage);
        //     await console.log(embeddedPage);
        //     let scaledEmbed = await embeddedPage.scale(0.95);
        //     await console.log("scaledEmbed", scaledEmbed);
        //     let page = await newPdfDoc.addPage(PageSizes.Letter);
        //     page.drawPage(embeddedPage, {
        //       ...scaledEmbed,
        //       x: page.getWidth() / 2 - scaledEmbed.width / 2,
        //       y: page.getHeight() /2 - scaledEmbed.height / 2,
        //     });

        //     //TEST ++++++++
        //     const helveticaFont = await newPdfDoc.embedFont(
        //       StandardFonts.Helvetica
        //     );
        //     const pages = await newPdfDoc.getPages();
        //     const firstPage = pages[0];
        //     const { width, height } = await firstPage.getSize();

        //     await console.log("docwidth", width);
        //     await console.log("docheight", height);
        //     let pageNumber = 0;

        //     await pages.forEach(page => {
        //       let prefix = `PREFIX`
        //       pageNumber++;
        //       let zeros;
        //       if(pageNumber < 10){
        //         zeros = `000000`
        //       } else if (pageNumber >= 10 && pageNumber < 100){
        //         zeros = `00000`
        //       } else if (pageNumber >= 100 && pageNumber < 1000){
        //         zeros = `0000`
        //       } else if (pageNumber >= 1000 && pageNumber < 10000){
        //         zeros = `000`
        //       } else if (pageNumber >= 10000 && pageNumber < 100000){
        //         zeros = `00`
        //       }

        //       page.drawText(`${prefix} - ${zeros}${pageNumber}`, {
        //         // x: 5,
        //         x: width - (width/4),
        //         // y: height / 2 + 300,
        //         y: height /20 - 35,
        //         size: 12,
        //         font: helveticaFont,
        //         color: rgb(0.95, 0.1, 0.1),
        //         // rotate: degrees()
        //       });
        //     });
        //     const pdfBytes = await newPdfDoc.save();

        //     this.newPDF = await URL.createObjectURL(
        //       new Blob([pdfBytes], {
        //         type: "application/pdf"
        //       })
        //     );
        //     return window.open(this.newPDF, "_blank");
        //   })();
        // });
      })();
    },

    // downloadResult(){
    //   const ref = firebase
    //         .app().storage("gs://taplaw_read_doc_test_results")
    //         .refFromURL(
    //           `gs://taplaw_read_doc_test_results/results/output-1-to-10.json`
    //         );
    //         ref
    //           .put(doc)
    //           .then(() => {
    //             console.log("testDoc successfully stored");
    //             this.documentList = [];
    //         }).catch(e=>{console.error(e)});
    //     })
    // },
    uploadDiscoveryDoc() {
      if (this.formIsValid) {
        this.documentList.forEach((doc) => {
          const docName = doc.name;
          const ref = firebase
            .app()
            .storage("gs://taplaw_read_doc_test")
            .ref(`matters/${this.matter.matterSlug}/readDocTest/${docName}`);
          ref
            .put(doc)
            .then(() => {
              console.log("testDoc successfully stored");
              this.documentList = [];
            })
            .catch((e) => {
              console.error(e);
            });
        });
      }
    },
    onFilePicked() {
      if (event.target.files) {
        const fileList = Array.from(event.target.files);
        fileList.forEach((file) => {
          this.documentList.push(file);
        });
      }
    },
    removeFile(index) {
      this.documentList.splice(index, 1);
    },
    logPlaintiffData() {
      console.log(this.plaintiff);
      console.log(window);
    },
    createAndStampTest() {
      console.log("starting..");
      pdfMake.fonts = {
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },

        Amiri: {
          normal: "Amiri-Regular.ttf",
          bold: "Amiri-Bold.ttf",
          italics: "Amiri-Italic.ttf",
          bolditalics: "Amiri-BoldItalic.ttf",
        },
        TimesRoman: {
          normal: "Times New Roman.ttf",
          bold: "Times New Roman Bold.ttf",
          italics: "Times New Roman Italic.ttf",
          bolditalics: "Times New Roman Bold Italic.ttf",
        },

        Wingdings: {
          normal: "Wingdings.ttf",
        },

        Zapfino: {
          normal: "Zapfino.ttf",
        },
      };
      let body = `On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue; and equal blame belongs to those who fail in their duty through weakness of will, which is the same as saying through shrinking from toil and pain. These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best, every pleasure is to be welcomed and every pain avoided. But in certain circumstances and owing to the claims of duty or the obligations of business it will frequently occur that pleasures have to be repudiated and annoyances accepted. The wise man therefore always holds in these matters to this principle of selection: he rejects pleasures to secure other greater pleasures, or else he endures pains to avoid worse pains.`;
      let docDef = {
        // ...
        background: () => {
          return [
            {
              style: "tableExample",
              table: {
                widths: [72, "*", 36],
                body: [
                  [
                    {
                      text: "",
                      border: [false],
                      margin: [0, 72, 0, 0],
                    },
                    {
                      text: "",
                      border: [true, false, true, false],
                    },
                    {
                      text: "",
                      border: [false],
                    },
                  ],
                  [
                    {
                      stack: [
                        { text: "1" },
                        { text: "2" },
                        { text: "3" },
                        { text: "4" },
                        { text: "5" },
                        { text: "6" },
                        { text: "7" },
                        { text: "8" },
                        { text: "9" },
                        { text: "10" },
                        { text: "11" },
                        { text: "12" },
                        { text: "13" },
                        { text: "14" },
                        { text: "15" },
                        { text: "16" },
                        { text: "17" },
                        { text: "18" },
                        { text: "19" },
                        { text: "20" },
                        { text: "21" },
                        { text: "22" },
                        { text: "23" },
                        { text: "24" },
                        { text: "25" },
                        { text: "26" },
                        { text: "27" },
                        { text: "28" },
                      ],
                      alignment: "right",
                      lineHeight: 1.8,
                      border: [false, false, true, false],
                      margin: [],
                    }, //END BACKGROUND STACK OBJECT
                    [
                      {
                        text: "",
                      },
                    ],
                    {
                      text: [" "],
                      border: [true, false, false, false],
                    },
                  ],
                ], //END BACKGROUND BODY ARRAY
              },
              layout: { defaultBorder: false }, //END BACKGROUND TABLE OBJECT
            }, //END BACKGROUND OBJECT
          ]; //END BACKGROUND RETURN ARRAY
        }, //END BACKGROUND

        //BEGIN FOOTER
        // footer: function(currentPage, pageCount){
        footer: (currentPage) => {
          return [
            {
              table: {
                widths: [72, "*", 36],
                // heights: [50, 50, 50],
                body: [
                  [
                    {
                      text: "",
                      border: [false, false, true, false],
                    },
                    {
                      stack: [
                        {
                          text: `${currentPage.toString()}`,
                          alignment: "center",
                          fontSize: 9,
                        },
                      ],
                      layout: { defaultBorder: false },
                      border: [false, true, false, false],
                    },
                    { text: "", border: [true, false, false, false] },
                  ],
                ],
              },
            },
          ];
        },
        //end footer
        // userPassword: '123',
        content: [
          // AUTHOR STACK
          {
            stack: [
              // { text: `${this.user.email}`, lineHeight: 0.6 },

              {
                text: `${this.plaintiff.username.toUpperCase()}`,
                lineHeight: 1.0,
              },

              {
                text: `Attorneys for:  ${
                  this.plaintiff.username.toUpperCase() || "Plaintiffs"
                }`,
                lineHeight: 1.0,
              },
            ],
            margin: [44, 2, 7, 0],
            lineHeight: 0,
            fontSize: 12,
          },
          //JURISDICTION STACK
          {
            stack: [
              {
                text: `SUPERIOR COURT OF THE STATE OF CALIFORNIA`,
                margin: [0, 40, 0, 0],
              },
              // {
              //   text: `FOR THE COUNTY OF ${this.matter.jdxCounty.toUpperCase() ||
              //     "null"}`
              // }
              {
                text: `FOR THE COUNTY OF ${this.matter.jdxCounty || "null"}`,
              },
            ],
            fontSize: 12,
            alignment: "center",
            lineHeight: 1,
            bold: true,
          },

          //BEGIN CAPTION STACK

          //BEGIN BODY STACK
          {
            text: `${body}`,
            fontSize: 12,
            alignment: "center",
            lineHeight: 1,
            bold: true,
          },
        ],
        pageMargins: [42, 78, 55, 40], //END CONENT SACK

        //BEGIN BACKGROUND STYLES
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 0, 0, 0],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
        defaultStyle: {
          // alignment: 'justify',
          font: "TimesRoman",
        },
        pageSize: "LETTER",
      }; //END (dd) DOCUMENT DENFENITION

      let doc = pdfMake.createPdf(docDef);
      doc.getBuffer((buffer) => {
        (async () => {
          await console.log("inside await in getbuffer");
          this.testDoc = buffer;
          await console.log("buffer from inside async", this.testDoc);

          //loading pdf we just created with pdfMake as an array buffer
          const generatedPDF = await PDFDocument.load(this.testDoc);
          await console.log("generatedPDF", generatedPDF);

          //now we cerate a new pdf with pdf-lib
          const newPdfDoc = await PDFDocument.create();
          //now we embed the created PDF
          let generatedPages = await generatedPDF.getPages();
          await console.log(generatedPages);
          await generatedPages.forEach((generatedPage) => {
            console.log("each page in generatedPages", generatedPage);
            (async () => {
              let embeddedPage = await newPdfDoc.embedPage(generatedPage);
              await console.log(embeddedPage);
              let scaledEmbed = await embeddedPage.scale(0.95);
              await console.log("scaledEmbed", scaledEmbed);
              let page = await newPdfDoc.addPage(PageSizes.Letter);
              page.drawPage(embeddedPage, {
                ...scaledEmbed,
                x: page.getWidth() / 2 - scaledEmbed.width / 2,
                y: page.getHeight() / 2 - scaledEmbed.height / 2,
              });

              //TEST ++++++++
              const helveticaFont = await newPdfDoc.embedFont(
                StandardFonts.Helvetica
              );
              const pages = await newPdfDoc.getPages();
              const firstPage = pages[0];
              const { width, height } = await firstPage.getSize();

              await console.log("docwidth", width);
              await console.log("docheight", height);
              let pageNumber = 0;

              await pages.forEach((page) => {
                let prefix = `PREFIX`;
                pageNumber++;
                let zeros;
                if (pageNumber < 10) {
                  zeros = `000000`;
                } else if (pageNumber >= 10 && pageNumber < 100) {
                  zeros = `00000`;
                } else if (pageNumber >= 100 && pageNumber < 1000) {
                  zeros = `0000`;
                } else if (pageNumber >= 1000 && pageNumber < 10000) {
                  zeros = `000`;
                } else if (pageNumber >= 10000 && pageNumber < 100000) {
                  zeros = `00`;
                }

                page.drawText(`${prefix} - ${zeros}${pageNumber}`, {
                  // x: 5,
                  x: width - width / 4,
                  // y: height / 2 + 300,
                  y: height / 20 - 35,
                  size: 12,
                  font: helveticaFont,
                  color: rgb(0.95, 0.1, 0.1),
                  // rotate: degrees()
                });
              });
              const pdfBytes = await newPdfDoc.save();

              this.newPDF = await URL.createObjectURL(
                new Blob([pdfBytes], {
                  type: "application/pdf",
                })
              );
              return window.open(this.newPDF, "_blank");
            })();
          });
        })();
      });
    },
  },
  created() {
    (async () => {
      await firebase
        .firestore()
        .collection("matters")
        .doc(this.$route.params.id)
        .collection("clients")
        .doc(this.$route.params.client)
        .onSnapshot((doc) => {
          this.plaintiff = doc.data();
        });

      await firebase
        .firestore()
        .collection("matters")
        .doc(this.$route.params.id)
        .collection("plaintiff")
        .doc(this.$route.params.client)
        .collection("readDocTest")
        .onSnapshot((res) => {
          const changes = res.docChanges();
          console.log(changes);
          changes.forEach((change) => {
            if (change.type === "added") {
              this.uploadOCRList = change.doc.data();
            } else if (change.type === "removed") {
              this.uploadOCRList = null;
            }
          });
        });
      await console.log("windowtitle:", window.document.title);
    })();
  },
};
</script>

<style scoped>
</style>


